import {useCallback} from "react";
import useErrorReporting from "shared/General/components/ErrorReporting/useErrorReporting";
import {copyToClipboard} from "../util/copyToClipboard";

export function useCopyToClipboard() {
    const {reportError} = useErrorReporting();

    const copyToClipboardWithReportError = useCallback(
        async (text: string): Promise<boolean> => {
            const copied = await copyToClipboard(text);
            if (!copied) {
                reportError(new Error("Failed to copy to clipboard"));
            }
            return copied;
        },
        [reportError],
    );

    return {
        copyToClipboard: copyToClipboardWithReportError,
    };
}
